import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './two-column-resposive-block.scss.js';

class TwoColumnResposiveBlock extends s {
    constructor() {
        super(...arguments);
        this.ctaStyleLeft = 'primary';
        this.ctaStyleRight = 'primary';
        this.ctaAlignSlotLeft = 'center';
        this.ctaAlignSlotRight = 'center';
    }
    firstUpdated() {
        const leftSlot = this.shadowRoot.querySelector('slot[name="left"]');
        const rightSlot = this.shadowRoot.querySelector('slot[name="right"]');
        const findElementDeep = (parent, selector) => {
            if (parent instanceof HTMLElement && parent.matches(selector))
                return parent;
            if (parent instanceof HTMLElement && parent.shadowRoot) {
                const shadowMatch = parent.shadowRoot.querySelector(selector);
                if (shadowMatch)
                    return shadowMatch;
            }
            for (const child of parent.childNodes) {
                if (child instanceof HTMLElement) {
                    const found = findElementDeep(child, selector);
                    if (found)
                        return found;
                }
            }
            return null;
        };
        // eslint-disable-next-line sonarjs/cognitive-complexity
        const syncHeightsAndWidths = () => {
            setTimeout(() => {
                const boxSize = 'border-box';
                const imageBlockComponent = 'image-block';
                const isMobile = window.innerWidth <= 768;
                const leftElements = leftSlot.assignedElements({ flatten: true });
                const rightElements = rightSlot.assignedElements({ flatten: true });
                const findElementInSlots = (selector) => [...leftElements, ...rightElements]
                    .map(el => findElementDeep(el, selector))
                    .find(el => el) || null;
                const getTargetSlot = (element) => leftElements.some(el => el.contains(element))
                    ? rightElements
                    : leftElements;
                const applyStyles = (targetElement, height) => {
                    if (!targetElement)
                        return;
                    const element = targetElement;
                    element.style.transition = 'none';
                    element.style.height = `${height}px`;
                    element.style.minHeight = `${height}px`;
                    element.style.width = '100%';
                    element.style.boxSizing = boxSize;
                };
                const processBlock = (blockElement, isHalfHeight = false) => {
                    if (!blockElement)
                        return;
                    const blockHeight = Math.round(blockElement.getBoundingClientRect().height);
                    const otherSlotElements = getTargetSlot(blockElement);
                    const imageBlockElement = otherSlotElements
                        .map(el => findElementDeep(el, imageBlockComponent))
                        .find(el => el) || null;
                    if (!imageBlockElement)
                        return;
                    if (isMobile && isHalfHeight) {
                        const { width } = imageBlockElement.getBoundingClientRect();
                        const halfHeight = blockHeight / 2;
                        if (width > 0 && halfHeight > 0) {
                            const aspectRatio = `${width} / (${halfHeight}`;
                            imageBlockElement.style.aspectRatio = aspectRatio;
                            imageBlockElement.style.removeProperty('height');
                            imageBlockElement.style.removeProperty('min-height');
                            const img = imageBlockElement.querySelector('img');
                            if (img) {
                                img.style.width = '100%';
                                img.style.height = '100%';
                                img.style.objectFit = 'cover';
                                img.style.objectPosition = 'center';
                            }
                        }
                    }
                    else {
                        applyStyles(imageBlockElement, isMobile && isHalfHeight ? blockHeight / 2 : blockHeight);
                    }
                };
                const responsiveGridElement = findElementInSlots('responsive-grid');
                if (responsiveGridElement) {
                    const categoryTileElement = findElementDeep(responsiveGridElement, 'category-tile-small');
                    const smallTileContainer = categoryTileElement
                        ? findElementDeep(categoryTileElement, 'a.small-tile-container')
                        : null;
                    const smallTileElement = smallTileContainer
                        ? findElementDeep(smallTileContainer, 'div.small-tile')
                        : null;
                    if (smallTileElement) {
                        const smallTileHeight = smallTileElement.offsetHeight || 0;
                        const otherSlotElements = getTargetSlot(responsiveGridElement);
                        const imageBlockElement = otherSlotElements
                            .map(el => findElementDeep(el, imageBlockComponent))
                            .find(el => el) || null;
                        const crossSellElement = otherSlotElements
                            .map(el => findElementDeep(el, 'cross-sell'))
                            .find(el => el) || null;
                        applyStyles(imageBlockElement, isMobile ? smallTileHeight / 2 : smallTileHeight);
                        if (imageBlockElement)
                            imageBlockElement.style.marginTop = '17px';
                        if (crossSellElement === null || crossSellElement === void 0 ? void 0 : crossSellElement.shadowRoot) {
                            const crossSellArticle = crossSellElement.shadowRoot.querySelector('article.multicolumn-cross');
                            applyStyles(crossSellArticle, smallTileHeight);
                        }
                    }
                    return;
                }
                processBlock(findElementInSlots('title-link-block'), true);
                processBlock(findElementInSlots('video-block'));
            }, 0);
        };
        this.mutationObserver = new MutationObserver(() => {
            syncHeightsAndWidths();
        });
        this.resizeObserver = new ResizeObserver(syncHeightsAndWidths);
        leftSlot.addEventListener('slotchange', syncHeightsAndWidths);
        rightSlot.addEventListener('slotchange', syncHeightsAndWidths);
        window.addEventListener('resize', syncHeightsAndWidths);
        [leftSlot, rightSlot].forEach(slot => {
            slot.assignedElements().forEach(element => {
                this.mutationObserver.observe(element, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                });
            });
        });
        syncHeightsAndWidths();
    }
    disconnectedCallback() {
        var _a, _b;
        super.disconnectedCallback();
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        (_b = this.mutationObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
    }
    renderCTA(slotName, ctaTyle, ctaAlign) {
        return x `<div class="cta-wrapper cta-${ctaTyle} align-${ctaAlign}"><slot name="${slotName}"></slot></div>`;
    }
    render() {
        return x `<div class="container-responsive has-divider"><div class="column"><div class="slot-container"><slot name="left"></slot>${this.renderCTA('cta-left', this.ctaStyleLeft, this.ctaAlignSlotLeft)}</div></div><div class="column"><div class="slot-container"><slot name="right"></slot>${this.renderCTA('cta-right', this.ctaStyleRight, this.ctaAlignSlotRight)}</div></div></div>`;
    }
}
TwoColumnResposiveBlock.styles = [css_248z];
__decorate([
    n({ type: String })
], TwoColumnResposiveBlock.prototype, "ctaStyleLeft", void 0);
__decorate([
    n({ type: String })
], TwoColumnResposiveBlock.prototype, "ctaStyleRight", void 0);
__decorate([
    n({ type: String })
], TwoColumnResposiveBlock.prototype, "ctaAlignSlotLeft", void 0);
__decorate([
    n({ type: String })
], TwoColumnResposiveBlock.prototype, "ctaAlignSlotRight", void 0);
customElements.define('two-column-resposive-block', TwoColumnResposiveBlock);

export { TwoColumnResposiveBlock };
